module.exports = __webpack_public_path__ + "img/icon-forgot-1.ee2b5b9b.svg";